const React = require("react");
const {
    View
} = require("react-native");

module.exports = {
    Camera: (props) => React.createElement(View, props),
    useCameraDevice: () => null,
    useCameraPermission: () => ({
        hasPermission: true,
        requestPermission: async () => true
    }),
    useCameraFormat: () => null,
    CameraFormat: {}
};
